/**
 * Widget 事件总线
 *
 * 管理 Widget 内部和外部的事件通信
 */

import type { WidgetEvent, EventHandler } from '../config/widget.types';

/**
 * Widget 事件总线类
 */
export class WidgetEventBus {
  private events = new Map<WidgetEvent, Set<EventHandler>>();

  /**
   * 监听事件
   */
  on(event: WidgetEvent, callback: EventHandler): void {
    if (!this.events.has(event)) {
      this.events.set(event, new Set());
    }
    this.events.get(event)!.add(callback);
  }

  /**
   * 取消监听
   */
  off(event: WidgetEvent, callback: EventHandler): void {
    this.events.get(event)?.delete(callback);
  }

  /**
   * 触发事件
   */
  emit(event: WidgetEvent, data?: any): void {
    this.events.get(event)?.forEach(callback => {
      try {
        callback(data);
      } catch (error) {
        console.error(`[SmartCS] 事件处理错误 (${event}):`, error);
      }
    });
  }

  /**
   * 清除所有监听器
   */
  clear(): void {
    this.events.clear();
  }

  /**
   * 获取事件的监听器数量
   */
  listenerCount(event: WidgetEvent): number {
    return this.events.get(event)?.size || 0;
  }
}

// 全局事件总线实例
let eventBusInstance: WidgetEventBus | null = null;

/**
 * 获取事件总线实例
 */
export function getEventBus(): WidgetEventBus {
  if (!eventBusInstance) {
    eventBusInstance = new WidgetEventBus();
  }
  return eventBusInstance;
}
